import React, { useState } from 'react';
import Button from "@mui/material/Button";
import axios from "axios";
export const TaskStatus = (props) => {
    const { taskStatus, taskId } = props;
    const [status, setStatus] = useState(taskStatus);
    const markTaskDone = async () => {
        setStatus('Done');
        const response = await axios.post('/api/tasks/markTaskDone', {
            taskId
        });
        if (props.onTaskUpdate && response.data.data.task) {
            props.onTaskUpdate(convertApiTaskToITask(response.data.data.task));
        }
    };
    const markTaskNotDone = async () => {
        setStatus(null);
        const response = await axios.post('/api/tasks/markTaskNotDone', {
            taskId
        });
        if (props.onTaskUpdate && response.data.data.task) {
            props.onTaskUpdate(convertApiTaskToITask(response.data.data.task));
        }
    };
    const convertApiTaskToITask = (apiTask) => {
        return {
            id: String(apiTask.id),
            taskName: apiTask.taskName,
            assignedTo: String(apiTask.assignedTo),
            assignedToName: apiTask.assignedToName,
            assignedBy: String(apiTask.assignedBy),
            assignedByName: apiTask.assignedByName,
            patientId: String(apiTask.patientId),
            patientName: apiTask.patientName || '',
            practiceId: String(apiTask.practiceId),
            status: apiTask.status,
            taskNotes: apiTask.taskNotes,
            dueDate: apiTask.dueDate,
            completedAt: apiTask.completedAt,
            lastReportId: apiTask.lastReportId,
            dob: apiTask.dob,
            practiceName: apiTask.practiceName || ''
        };
    };
    return (React.createElement("div", { className: 'table-cell pt-4 pb-4 align-middle text-center' }, status === 'Done' ?
        React.createElement(Button, { onClick: markTaskNotDone, variant: 'contained', style: {
                fontFamily: 'Barlow',
                backgroundColor: '#2E7D32',
                color: '#FFFFFF',
                borderRadius: 18,
                boxShadow: 'none'
            } }, "Done")
        :
            React.createElement(Button, { onClick: markTaskDone, variant: 'contained', style: {
                    fontFamily: 'Barlow',
                    backgroundColor: '#F2F2F5',
                    color: '#121417',
                    borderRadius: 18,
                    boxShadow: 'none'
                } }, "Mark Done")));
};
